import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { DirectTreasurySellOfferEntityNormalized } from '../../../../../../../../../store/product/types';

import { DirectTreasuryListItemDesktop } from './desktop';
import { DirectTreasuryListItemMobile } from './mobile';
import { DirectTreasuryListItemTablet } from './tablet';

export namespace DirectTreasuryListItemTypes {
  export interface Props {
    offer: DirectTreasurySellOfferEntityNormalized;
  }
}

export const DirectTreasurySellListItem: React.FC<DirectTreasuryListItemTypes.Props> = ({
  offer,
}) => {
  const directTreasuryListItem = useBreakpointValue({
    base: <DirectTreasuryListItemMobile offer={offer} />,
    sm: <DirectTreasuryListItemTablet offer={offer} />,
    lg: <DirectTreasuryListItemDesktop offer={offer} />,
  });

  return directTreasuryListItem;
};
